import React from "react";
import {
    Heading,
    ListItem,
    List,
    Text
} from "spectacle";
import Button from '../components/Button';

const HeadlessBootcamp = () =>
    <div>
        <Heading size={6} textColor="fifth" caps>
            Sitecore Headless / JSS Boot camp
        </Heading>
        <Text textSize={30} textColor="primary">
            Get ready for the paradigm shift in Sitecore solution development with modern JavaScript
        </Text>
        <List ordered textColor="primary" style={{paddingLeft: '25px', listStylePosition: 'outside'}}>
            <ListItem textSize={25}>Demystify the Headless CMS</ListItem>
            <ListItem textSize={25}>Discover the richness of Sitecore contextual content delivery APIs</ListItem>
            <ListItem textSize={25}>Learn how to leverage latest and greatest JavaScript technologies</ListItem>
            <ListItem textSize={25}>Learn how to build headless digital solutions that make your marketers happy too!</ListItem>
            <ListItem textSize={25}>Engage your front-end development team on a whole new level</ListItem>
            <ListItem textSize={25}>Unlock new scenarios beyond the browser</ListItem>
            <ListItem textSize={25}>Prototype your project with Sitecore JSS</ListItem>
        </List>
        <Button targetUrl='https://altola.co/bootcamps/jss' />
    </div>

export default HeadlessBootcamp;


// WEBPACK FOOTER //
// ./src/slides/HeadlessBootcamp.js